import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CategoryTabs from "./CategoryTabs";
import API_KEY from "../../../../api/index";
import { Skeleton } from "antd";
import { sendData } from "store/firebase/methods";

export default function Index() {
  const [collectionDetails, setCollectionDetails] = useState(null);
  const [saving, setSaving] = useState(false);
  const params = useParams();

  // const history = useHistory();
  const collectionId = params?.id;
  const type = params?.type;
  // const [globalState, setGlobalState] = useGlobal();
  // const { collections } = globalState;
  const [tableData, setTableData] = useState(null);
  const [showInternals, setShowInternals] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("routing-path")) {
      sessionStorage.removeItem("routing-path");
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    API_KEY.URL.get(`${API_KEY.path.table}/${collectionId}`)
      .then((res) => {
        const data = res.data?.data?.[0];
        console.log("data:", data);
        mapData(data);
        setCollectionDetails(data);
        sessionStorage.setItem("collectionDetails", JSON.stringify(data));
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [collectionId]);

  const refreshCollection = () => {
    setLoading(true);
    API_KEY.URL.get(`${API_KEY.path.table}/${collectionId}`)
      .then((res) => {
        mapData(res.data?.data?.[0]);
        setCollectionDetails(res.data?.data?.[0]);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  //category wise data
  const mapData = (data) => {
    let selecteProducts = [];

    data?.products?.forEach((product) => {
      let categoryName = product?.products_id?.secondary_categoryname;
      let categoryId = product?.products_id?.secondary_categoryid;
      let id = product?.products_id?.id;

      let productObj = {
        collection_product_id: product?.id,
        product_id: product?.products_id?.product_id,
        product_images: product?.products_id?.product_images,
        attributes: product?.attributes,
        prodId: id,
        visible_attributes: product?.visible_attributes,
        hasVariant: product?.hasVariant,
        numVariants: product?.numVariants,
        is_exclusive_product: product?.is_exclusive_product,
        exclusive_buyer_details: product?.exclusive_buyer_details,
      };
      selecteProducts.push({
        primary_key: { name: categoryName, id: categoryId },
        secondary_key: { productObj },
      });
    });

    if (selecteProducts.length > 0) {
      const products = selecteProducts.map((item) => {
        delete item?.secondary_key?.productObj?.id;
        return {
          secondary_category: { ...item.primary_key },
          ...item.secondary_key?.productObj,
          id: item.secondary_key?.productObj?.prodId,
        };
      });

      // localStorage.setItem("selectedProducts", JSON.stringify(products));
      sendData(products);
    } else {
      // localStorage.setItem("selectedProducts", JSON.stringify([]));
      sendData([]);
    }

    const result = Object.values(
      selecteProducts.reduce(
        (
          acc,
          {
            primary_key: { name },
            primary_key: { id },
            secondary_key: { productObj },
          }
        ) => {
          acc[name] = acc[name] || { name, values: [], id };
          acc[name].values.push(productObj);
          return acc;
        },
        {}
      )
    );

    setTableData(result);
  };

  return (
    <>
      {loading ? (
        <div className="loader">
          <Skeleton active />
        </div>
      ) : (
        <CategoryTabs
          showInternals={showInternals}
          setShowInternals={setShowInternals}
          tableData={tableData}
          collectionDetails={collectionDetails}
          collectionId={collectionId}
          type={type}
          setSaving={setSaving}
          saving={saving}
          setLoading={setLoading}
          setTableData={setTableData}
          refreshCollection={refreshCollection}
        />
      )}
    </>
  );
}
